import { useMemo } from "react";
import { useSelector } from "react-redux";

import { selectSettings } from "../store/settings/settingsSlice";
import { SHOPIFY_ENV } from "../utils";

export const useShopifyApp = () => {
  const { env } = useSelector(selectSettings);

  const isShopifyApp = SHOPIFY_ENV.includes(env?.hostEnv);

  return useMemo(() => isShopifyApp, [isShopifyApp]);
};
